<template>
    <h4 class="card-post-title" :class="{'card-post-title--small': small}">
        <slot></slot>
    </h4>
</template>

<script>
    export default {
        name: 'Title',
        props: {
            small: Boolean,
        }
    }
</script>

<style lang="scss" scoped>
    .card-post-title {
        font-style: normal;
        font-weight: bold;
        font-size: $dashboard-font-size-medium-title;
        line-height: 21px;
        color: $dashboard-text;

        &--small {
            font-size: 12px;
            line-height: 18px;
        }

        &:not(:last-child) {
            margin-bottom: $card-margin;
        }
    }
</style>